import { useContext } from 'react';
import { SelectionStateContext } from './SelectionContext';

export const useSelectionState = () => {
  const selectionState = useContext(SelectionStateContext);

  if (!selectionState) {
    throw new Error('Selection state context not initialized!');
  }

  return selectionState;
};
